import { ShipmentInProcessContract } from "../../domain/contracts/shipment_in_process_contract";
import { shipmentInProcessEntity } from "../../domain/entities/shipment_in_process_entity";
import http from "../../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpShipmentsInProcessRepository = {
    ...ShipmentInProcessContract,
    model: shipmentInProcessEntity,

    async external_shipments_index() {
        const res = await http.get('v1/advanced_external_fulfillment/get_shipments_in_process');

        return res;
    },

    async external_shipments_release(trace_id) {
        const res = await http.delete(`v1/advanced_external_fulfillment/release_orders/${trace_id}`);

        return res;
    },
    
    async shipments_index() {
        const res = await http.get('v1/advanced_fulfillment/get_shipments_in_process');

        return res;
    },

    async shipments_release(trace_id) {
        const res = await http.delete(`/v2/advanced-fulfillment/${trace_id}/release`);

        return res;
    }
};